/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import store from "@/store/store";

Vue.use(Router);
const pages_login_path = "/pages/login";
const current_app_path = "/";
const kcs_default_path = "/shipping-review";
const thungan_default_path = "/shipping-overview";
const accountant_default_path = "/accountant-view";
const accountant_default_pathbb = "/accountant-view-bb";
const admin_xh_path = "/dashboard-ta";
const kcsxh_default_path = "/sos-review";
const router = new Router({
	mode: "history",
	base: '/',
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			// =============================================================================
			// MAIN LAYOUT ROUTES
			// =============================================================================
			path: "",
			// component: () => import("./layouts/main/Main.vue"),
			component: () => import("@/layouts/full-page/Custom.vue"),
			children: [
				// =============================================================================
				// Theme Routes
				// =============================================================================

				// {
				// 	path: "/",
				// 	redirect: "/dashboard/customers"
				// },
				// {
				// 	path: "/",
				// 	name: "dashboard",
				// 	// component: () => import("./views/apps/customer/CustomerView.vue"),
				// 	component: () => import("./views/apps/user/UserViewDashboard.vue"),
				// 	meta: {
				// 		authRequired: true,
				// 		rule: "isEditor"
				// 	}
				// },

				{
					path: "/",
					name: "page-test",
					component: () => import("@/views/apps/user/ListSellView2.vue"),
					meta: {
						// authRequired: false,
						rule: "isEditor",
					},
				},

				{
					path: "/nhat-ky-kcs",
					name: "nhat-ky-kcs",
					component: () => import("@/views/apps/user/NhatKyKcs.vue"),
					meta: {
						authRequired: true,
						rule: "isEditor",
					},
				},

				{
					path: "/nhat-ky-kcs-toan-bo",
					name: "nhat-ky-kcs",
					component: () => import("@/views/apps/user/NhatKyKcsAll.vue"),
					meta: {
						authRequired: false,
						rule: "isEditor",
					},
				},




				// {
				// 	path: "/san-pham-can-mua-ban",
				// 	name: "dashboard-technical",
				// 	component: () => import("./views/apps/user/SPCM.vue"),
				// 	meta: {
				// 		rule: "isEditor",
				// 	},
				// },
				// {
				// 	path: "/ban-do-tong-quan",
				// 	name: "dashboard-technical",
				// 	component: () => import("./views/apps/user/BanDo.vue"),
				// 	meta: {
				// 		rule: "isEditor",
				// 	},
				// },










				{
					path: "/home",
					name: "dashboard-technical",
					component: () => import("./views/apps/user/DashView.vue"),
					meta: {
						authRequired: true,
						rule: "isEditor",
					},
				},

				{
					path: admin_xh_path,
					name: "dashboard-ta",
					component: () => import("./views/apps/user/DashViewAdminXh.vue"),
					meta: {
						authRequired: true,
						rule: "isAdminXH",
					},
				},

				{
					path: "/so-lenh",
					name: "dashboard-technical",
					component: () => import("./views/apps/user/OrderView.vue"),
					meta: {
						authRequired: true,
						rule: "isEditor",
					},
				},

				{
					path: "/dashboard",
					name: "dashboard-products",
					component: () => import("./views/apps/user/DashboardView.vue"),
					meta: {
						authRequired: true,
						rule: "isEditor",
					},
				},

				{
					path: kcs_default_path,
					name: "shipping-review",
					component: () => import("./views/apps/user/ShippingView.vue"),
					meta: {
						authRequired: true,
						rule: "isKCS",
					},
				},

				{
					path: kcsxh_default_path,
					name: "sos-review",
					component: () => import("./views/apps/user/SosView.vue"),
					meta: {
						authRequired: true,
						rule: "isKCSXH",
					},
				},
				
				{
					path: '/thungan-backdoor-detail',
					name: "thungan-backdoor-detail",
					component: () => import("./views/apps/user/ThuNganBackdoor.vue"),
					meta: {
						// authRequired: true,
						rule: "isEditor",
					},
				},

				{
					path: '/thungan-backdoor-dashboard',
					name: "thungan-backdoor-dashboard",
					component: () => import("./views/apps/user/ThuNganBackdoorDash.vue"),
					meta: {
						// authRequired: true,
						rule: "isEditor",
					},
				},


				{
					path: '/sale-shippings',
					name: "sale-shippings",
					component: () => import("./views/apps/user/SaleShippings.vue"),
					meta: {
						authRequired: true,
						rule: "isEditor",
					},
				},


				{
					path: '/sale-shippings-backdoor',
					name: "sale-shippings",
					component: () => import("./views/apps/user/SaleShippingsBackdoor.vue"),
					meta: {
						// authRequired: true,
						rule: "isEditor",
					},
				},


				{
					path: thungan_default_path,
					name: "shipping-overview",
					component: () => import("./views/apps/user/ShippingOverview.vue"),
					meta: {
						authRequired: true,
						rule: "isThuNgan",
					},
				},

				{
					path: '/shipping-dashboard',
					name: "shipping-dashboard",
					component: () => import("./views/apps/user/ShippingDashboard.vue"),
					meta: {
						authRequired: true,
						rule: "isThuNgan",
					},
				},

				{
					path: accountant_default_path,
					name: "accountant-view",
					component: () => import("./views/apps/user/AccountantView.vue"),
					meta: {
						authRequired: false,
						rule: "isAccountant",
					},
				},

				{
					path: accountant_default_pathbb,
					name: "accountant-view-bb",
					component: () => import("./views/apps/user/AccountantViewBB.vue"),
					meta: {
						authRequired: false,
						rule: "isAccountantBB",
					},
				},
				
				// {
				// 	path: kcs_default_path,
				// 	name: "kcs-review",
				// 	component: () => import("./views/apps/user/MatchingView.vue"),
				// 	meta: {
				// 		authRequired: true,
				// 		rule: "isKCS",
				// 	},
				// },

				{
					path: 'kcs-detail/:id',
					name: "kcs-review",
					component: () => import("./views/apps/user/KcsDetail.vue"),
					meta: {
						authRequired: true,
						rule: "isKCS",
					},
				},

				// {
				// 	path: "/nhan-vien-c1",
				// 	name: "dashboard-technical",
				// 	component: () => import("./views/apps/user/UserC1View.vue"),
				// 	meta: {
				// 		authRequired: true,
				// 		rule: "isEditor",
				// 	},
				// },
				// {
				// 	path: "/nhan-vien-c2",
				// 	name: "dashboard-technical",
				// 	component: () => import("./views/apps/user/UserC2View.vue"),
				// 	meta: {
				// 		authRequired: true,
				// 		rule: "isEditor",
				// 	},
				// },
				// {
				// 	path: "/nhan-vien-c3",
				// 	name: "dashboard-technical",
				// 	component: () => import("./views/apps/user/UserC3View.vue"),
				// 	meta: {
				// 		authRequired: true,
				// 		rule: "isEditor",
				// 	},
				// },
				// {
				// 	path: "/nhan-vien-c4",
				// 	name: "dashboard-technical",
				// 	component: () => import("./views/apps/user/UserC4View.vue"),
				// 	meta: {
				// 		authRequired: true,
				// 		rule: "isEditor",
				// 	},
				// },

				// {
				// 	path: "/can-ho-tro",
				// 	name: "dashboard-technical",
				// 	component: () => import("./views/apps/user/UserHelpView.vue"),
				// 	meta: {
				// 		authRequired: true,
				// 		rule: "isEditor"
				// 	}
				// }
				// {
				// 	path: "/dashboard/maps",
				// 	name: "dashboard-maps",
				// 	component: () => import("./views/apps/maps/MapView.vue"),
				// 	meta: {
				// 		authRequired: true,
				// 		rule: "isEditor"
				// 	}
				// },
				// {
				// 	path: "/dashboard/tracking",
				// 	name: "dashboard-tracking",
				// 	component: () => import("./views/apps/tracking/TrackingView.vue"),
				// 	meta: {
				// 		authRequired: true,
				// 		rule: "isSpecial"
				// 	}
				// }

				// =============================================================================
				// Pages Routes
				// =============================================================================
				{
					path: "/pages/profile",
					name: "page-user-settings",
					component: () => import("@/views/pages/user-settings/UserSettings.vue"),
					meta: {
						breadcrumb: [{ title: "Home", url: "/" }, { title: "Thông tin cá nhân", active: true }],
						pageTitle: "Cài đặt",
						rule: "isEditor"
					}
				}
			],
		},
		// =============================================================================
		// FULL PAGE LAYOUTS
		// =============================================================================
		{
			path: "",
			component: () => import("@/layouts/full-page/Custom.vue"),
			children: [
				{
					path: "/cac-lenh-ban",
					name: "cac-lenh-ban",
					component: () => import("@/views/apps/user/ListSellView.vue"),
					meta: {
						rule: "isBuyer",
					},
				},
				{
					path: "/chi-tiet-lenh-ban/:id",
					name: "chi-tiet-lenh-ban",
					component: () => import("@/views/apps/user/DetailSellView.vue"),
					meta: {
						rule: "isBuyer",
					},
				},
			]
		},
		{
			path: "",
			component: () => import("@/layouts/full-page/FullPage.vue"),
			children: [
				// =============================================================================
				// PAGES
				// =============================================================================				
				{
					path: "/callback",
					name: "auth-callback",
					component: () => import("@/views/Callback.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/login",
					name: "page-login",
					component: () => import("@/views/pages/login/Login.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/comay-online/lien-he",
					name: "comay-online-lien-he",
					component: () => import("@/views/pages/contact/Contact.vue"),
					meta: {
						rule: "isEditor",
					},
				},
				{
					path: "/pages/register",
					name: "page-register",
					component: () => import("@/views/pages/register/Register.vue"),
					meta: {
						rule: "isEditor",
					},
				},
				{
					path: "/pages/forgot-password",
					name: "page-forgot-password",
					component: () => import("@/views/pages/ForgotPassword.vue"),
					meta: {
						rule: "isEditor",
					},
				},
				{
					path: "/pages/reset-password",
					name: "page-reset-password",
					component: () => import("@/views/pages/ResetPassword.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/lock-screen",
					name: "page-lock-screen",
					component: () => import("@/views/pages/LockScreen.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/comingsoon",
					name: "page-coming-soon",
					component: () => import("@/views/pages/ComingSoon.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/error-404",
					name: "page-error-404",
					component: () => import("@/views/pages/Error404.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/error-500",
					name: "page-error-500",
					component: () => import("@/views/pages/Error500.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/not-authorized",
					name: "page-not-authorized",
					component: () => import("@/views/pages/NotAuthorized.vue"),
					meta: {
						rule: "editor",
					},
				},
				{
					path: "/pages/maintenance",
					name: "page-maintenance",
					component: () => import("@/views/pages/Maintenance.vue"),
					meta: {
						rule: "editor",
					},
				},
			],
		},
		// Redirect to 404 page, if no match found
		{
			path: "*",
			redirect: "/pages/error-404",
		},
	],
});

router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById("loading-bg");
	if (appLoading) {
		appLoading.style.display = "none";
	}
});

router.beforeEach((to, from, next) => {
	// if (to.path == 'nhat-ky-kcs') {
	// 	return next({
	// 		path: '/nhat-ky-kcs',
	// 		replace: true
	// 	});
	// }
	if (to.path === pages_login_path) {
		if (store.state.auth.isUserLoggedIn()) {
			return router.push({
				path: current_app_path,
			});
		}
	}
	// If auth required, check login. If login fails redirect to login page
	if (to.meta.authRequired) {
		if (!store.state.auth.isUserLoggedIn()) {
			router.push({ path: "/pages/login", query: { to: to.path } });
		}
	}

	if (to.path == current_app_path) {
		let role = store.state.auth.getUserRole();
		if (role == 'kcs') {
			return router.push({
				path: kcs_default_path,
			});
		}
		if (role == 'kcsxh') {
			return router.push({
				path: kcsxh_default_path,
			});
		}
		if (role == 'thungan') {
			return router.push({
				path: thungan_default_path,
			});
		}
		if (role == 'accountant') {
			return router.push({
				path: accountant_default_path,
			});
		}
		if (role == 'accountantbb') {
			return router.push({
				path: accountant_default_pathbb,
			});
		}
		if (role == 'admin-xuat-hang') {
			return router.push({
				path: admin_xh_path,
			});
		}
		
	}	

	return next();
});

export default router;
